import { Component, Input } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'share-link',
  templateUrl: 'share-link.component.html',
  styleUrls: ['share-link.component.scss']
})
export class ShareLinkComponent {
  @Input() link: string;
  @Input() linkActive: boolean = false;
  @Input() nameIncompleted: string = 'Still Processing';
  @Input() nameCompleted: string = 'Share Link';
  @Input() completed: boolean = false;
  @Input() inactive: boolean = false;
  @Input() isFailed: boolean = false;
  @Input() isOnlyIcon: boolean = false;
  @Input() icon: string = 'download-icon';

  get isLinkAvailable(): boolean {
    return (this.completed && !this.inactive && !this.isFailed && !!this.link);
  }

  onLinkClick(event: any) {
    if (this.isLinkAvailable && this.linkActive) {
        console.log('Link copied');
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (this.link));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        alert('File link copied to clipboard');
    }
  }
}
